import { IshipAddres } from '../../interfaces';

export const createEmptyAddress = (): IshipAddres => ({
  id: '',
  firstName: '',
  lastName: '',
  addressLine1: '',
  addressLine2: '',
  country: '',
  province: '',
  city: '',
  postcode: '',
  telephone: '',
  phoneCode: '',
  emoji: '',
  useAddressForBilling: false,
});
